import { Col, Row, Typography } from "antd";
import styles from "./BoxSectionItem.module.scss";

export interface IBoxSectionItemProps {
  textLeft: string;
  textRight: any;
  ellipsis?: boolean;
}

const { Text } = Typography;

const BoxSectionItem = ({
  textLeft,
  textRight,
  ellipsis = false,
}: Partial<IBoxSectionItemProps>) => {
  return (
    <Row gutter={[16, 0]} className={styles.container}>
      <Col span={12} xs={24} md={12}>
        <Text ellipsis={ellipsis ? { tooltip: textLeft } : false}>
          {textLeft}
        </Text>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Text
          className={styles.textRight}
          strong
          ellipsis={ellipsis ? { tooltip: textRight } : false}
        >
          {textRight}
        </Text>
      </Col>
    </Row>
  );
};

export default BoxSectionItem;
